export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'shenghuo-meixue',
    name: '生活美学',
    description: '探索日常生活中的艺术与美感，从家居布置到日常仪式，发现让生活更精致的方式与灵感。',
    icon: 'ri-palette-line',
    articleCount: 42,
    imageSeq: 'cat-life-aesthetics',
  },
  {
    slug: 'shendu-yuedu',
    name: '深度阅读',
    description: '精选思想深刻、内容丰富的长篇好文，涵盖人文社科、哲学思辨、文学评论等领域的优质内容。',
    icon: 'ri-book-open-line',
    articleCount: 38,
    imageSeq: 'cat-deep-reading',
  },
  {
    slug: 'renwu-fengshang',
    name: '人物风尚',
    description: '聚焦时代人物故事与品格风尚，呈现不同领域杰出人士的思想、经历与生活态度。',
    icon: 'ri-user-star-line',
    articleCount: 29,
    imageSeq: 'cat-people-style',
  },
  {
    slug: 'keji-qianyan',
    name: '科技前沿',
    description: '追踪全球科技创新趋势，深度解读人工智能、可持续发展、医疗健康等前沿领域的突破性进展。',
    icon: 'ri-cpu-line',
    articleCount: 35,
    imageSeq: 'cat-tech-frontier',
  },
  {
    slug: 'yishu-sheji',
    name: '艺术设计',
    description: '品味当代艺术与设计的魅力，从视觉艺术到空间设计，感受创意与美学的无限可能。',
    icon: 'ri-paint-brush-line',
    articleCount: 27,
    imageSeq: 'cat-art-design',
  },
  {
    slug: 'jiankang-yangsheng',
    name: '健康养生',
    description: '关注身心平衡与健康生活方式，分享科学养生知识、营养饮食指南与心理健康智慧。',
    icon: 'ri-heart-pulse-line',
    articleCount: 31,
    imageSeq: 'cat-health-wellness',
  },
];